module.exports = __webpack_public_path__ + "static/media/image3.9daf3056.webp";